import { useState } from 'react';

import { EXTERNAL_TOOLS, ExternalTool } from '../../../config/external-tools';
import { openExternalTool } from '../../../utils/external-tool.service';
import { PANEL_HEIGHT } from '../launch.constants';
import { Panel, PanelHeader, PanelTitle, PanelSubtitle } from '../styles';
import { ToolRow } from './ToolRow';

export const ExternalToolsPanel = () => {
  const [openedTool, setOpenedTool] = useState<string | null>(null);

  const handleOpen = (tool: ExternalTool) => {
    setOpenedTool(tool.id);
    openExternalTool(tool);
    setTimeout(() => setOpenedTool(null), 2000);
  };

  return (
    <Panel style={{ height: PANEL_HEIGHT }}>
      <PanelHeader>
        <PanelTitle>Herramientas externas</PanelTitle>
        <PanelSubtitle>Acceso con SSO automático</PanelSubtitle>
      </PanelHeader>

      {EXTERNAL_TOOLS.map((tool) => (
        <ToolRow
          key={tool.id}
          tool={tool}
          isOpening={openedTool === tool.id}
          onOpen={handleOpen}
        />
      ))}
    </Panel>
  );
};
